import { ref } from "vue";

export const voucherSequenceAlerts = ref({ data: [], total: 0 });
let requestId = 0;
let lastAppliedId = 0;
const pendingRoutes = new Set();

export const prepareVoucherAlertRequest = (config, route) => {
  const method = String(config.method || "get").toLowerCase();
  const required = config.voucherAlerts === true
    || !["get", "head", "options"].includes(method)
    || !pendingRoutes.has(route);
  if (!required) return;
  config.headers["X-Voucher-Alerts"] = "1";
  config.metadata.voucherAlertRequest = { id: ++requestId, route };
  pendingRoutes.add(route);
};

export const applyVoucherSequenceAlerts = (section, id = ++requestId) => {
  if (!section || section.available !== true || !Array.isArray(section.data) || id < lastAppliedId) return false;
  lastAppliedId = id;
  voucherSequenceAlerts.value = { data: section.data, total: section.data.length };
  return true;
};

export const finishVoucherAlertRequest = (config, body) => {
  const request = config?.metadata?.voucherAlertRequest;
  if (request) pendingRoutes.delete(request.route);
  const section = body?.voucherSequenceAlerts || body?.snapshot?.voucherSequences;
  if (!section) return;
  applyVoucherSequenceAlerts(section, request?.id);
};

export const clearVoucherSequenceAlerts = () => {
  voucherSequenceAlerts.value = { data: [], total: 0 };
  lastAppliedId = ++requestId;
  pendingRoutes.clear();
};
